export default __webpack_public_path__ + "static/media/koleos-medium1.35bb080b.jpg";